import React, { useEffect, useRef, useState } from 'react';
import { Avatar } from '@mui/material';
import { resolveThumbUrlFromIndexedDb } from '../utils/indexedDb';

/**
 * CachedAvatar
 * - Resuelve una URL de imagen potencialmente cacheada en IndexedDB
 * - Limpia correctamente los object URLs creados con URL.revokeObjectURL
 *
 * Props: acepta las mismas props que MUI Avatar
 *  - src: thumb_url original a resolver
 */
const CachedAvatar = ({ src, ...avatarProps }) => {
  const [resolvedSrc, setResolvedSrc] = useState('');
  const previousObjectUrlRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      const url = await resolveThumbUrlFromIndexedDb(src || '');

      if (!isMounted) {
        if (url && typeof url === 'string' && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
        return;
      }

      // Revocar el object URL anterior si existía y es distinto
      if (
        previousObjectUrlRef.current &&
        previousObjectUrlRef.current !== url
      ) {
        URL.revokeObjectURL(previousObjectUrlRef.current);
        previousObjectUrlRef.current = null;
      }

      setResolvedSrc(url || '');

      if (url && typeof url === 'string' && url.startsWith('blob:')) {
        previousObjectUrlRef.current = url;
      } else {
        previousObjectUrlRef.current = null;
      }
    })();

    return () => {
      isMounted = false;
      if (previousObjectUrlRef.current) {
        URL.revokeObjectURL(previousObjectUrlRef.current);
        previousObjectUrlRef.current = null;
      }
    };
  }, [src]);

  return (
    <Avatar src={resolvedSrc} {...avatarProps} />
  );
};

export default CachedAvatar;


